module.exports = __webpack_public_path__ + "img/dylan-gillis-533818-unsplash.0c3edc78.jpg";